import {
    genericPage,
    getServerSidePropsHelper,
    getSlugEleccio,
    getMappingEleccions3CatInfo,
    getBasePathEleccio
} from 'components/3catinfo/Page';
import { useRouter } from 'next/router';
import __isEmpty from 'lodash/isEmpty';

const Pagina = (props) => {
    const router = useRouter();
    return genericPage(props, router, ['web', process.env.FOLDER_LAYOUTS_3CATINFO, 'eleccions']);
};

export async function getServerSideProps(context) {
    const slugEleccio = getSlugEleccio(context?.resolvedUrl);
    const basePath = getBasePathEleccio(context?.resolvedUrl);

    const path = [...basePath, 'pactometre'];
    const mapping = await getMappingEleccions3CatInfo(slugEleccio);
    if (__isEmpty(mapping)) {
        return {
            notFound: true
        };
    }

    const options = {
        slugs: path,
        id: mapping.id,
        slugEleccio
    };
    return getServerSidePropsHelper(context, options);
}

export default Pagina;
